import { Component, OnInit, Input, Output, EventEmitter, DoCheck, OnChanges } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
  UntypedFormArray,
  FormGroupDirective,
  NgForm,
} from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';

import { TeamDetails, AddTeam, TeamMemberDetails, DeleteTeam } from '../../models/operations_persona';
import { UpdateTeam } from '../../models/operations_persona';
import { TeamService } from '../../services/team.service';

import { DatePipe } from '@angular/common';
import { EventDetails } from '../../models/event';
import { Observable } from 'rxjs/internal/Observable';
import { startWith } from 'rxjs/internal/operators/startWith';
import { map } from 'rxjs/operators';
import { ErrorStateMatcher } from '@angular/material/core';
export interface Time {
  value: number;
  viewValue: string;
}
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
@Component({
  selector: 'app-team-member',
  templateUrl: './team-member.component.html',
  styleUrls: ['./team-member.component.scss'],
  standalone: false,
})
export class TeamMemberComponent implements OnInit, DoCheck, OnChanges {
  matcher = new MyErrorStateMatcher();
  @Input() teamData: TeamMemberDetails[] = [];
  @Input() role = '';
  @Input() displayChart;
  times: Time[] = [
    { value: 1, viewValue: 'Full-Day' },
    { value: 2, viewValue: 'Half-Day' },
  ];
  @Input() disableallocate: boolean;
  private selectedTeamMember;
  public edited = false;
  ripcolor: any = '';
  id: any;
  val: number;
  selectedData;
  selectedDate;
  selectedToDate;
  todaydate: Date = new Date();
  inputText: string = '';
  fdate: string;
  todate: string;
  minDate = new Date(2000, 0, 1);
  maxDate = new Date(2021, 0, 1);
  errorMessage: string;
  companyHiringTypeId: number;
  updateTeamData: UpdateTeam = <UpdateTeam>{};
  deleteTeamData: DeleteTeam = <DeleteTeam>{};
  @Input() closeOverlay: boolean;
  @Input() eventDetails: EventDetails;
  @Output() addTeamMember = new EventEmitter();
  @Output() leaveUpdate = new EventEmitter();
  @Output() deleteMember = new EventEmitter();
  @Output() autoAllocate = new EventEmitter();
  memberDetails: TeamDetails = <TeamDetails>{};
  addDetails: TeamDetails = <TeamDetails>{};
  addMemberData: AddTeam = <AddTeam>{};
  empImage = 'assets/images/avatar2.png';
  member: any = {
    empImage: 'assets/images/avatar1.png',
  };
  leaveCount = 0;
  selectedMember;
  chartData = {
    data: [10, 10, 20, 30],
    labels: ['Pending', 'Backlog', 'Fresh', 'Processed'],
    type: 'doughnut',
    doughnutChartColors: [{ backgroundColor: ['#0062FF', '#FFC542', '#FF974A', '#3DD598'] }],
    options: {
      cutoutPercentage: 80,
      responsive: true,
      maintainAspectRatio: false,
    },
    legend: false,
    centerText: '10',
    width: 100,
    height: 40,
    id: 'team-stats',
  };
  companyHiringType = localStorage.getItem('fresherCompHiringTypeId');
  selectedMemberRole: any;
  teamControl = new UntypedFormControl();
  filteredOptions: Observable<TeamMemberDetails[]>;
  showInput: boolean = false;
  teamSearch = new UntypedFormControl('', [Validators.pattern('^[a-zA-Z]*$')]);
  filteredTeamData: TeamMemberDetails[];
  isOpen: boolean = false;
  triggerOrigin: any;
  showInputFields: boolean = false;
  unitListArray: any[] = [];
  sourceListArray: any[] = [];
  sourceIdwithType: any;
  filteredUnits: any[] = [];
  filteredSource: any[] = [];
  selectedUnit: string = '';
  selectedSource: string = '';
  teamArray: any[] = [];
  teamArr: any[] = [];
  teamMemberData: TeamMemberDetails[];
  activeState: number;
  profilecount: any;
  hideDeleteBtn: boolean = false;
  disableAssign: boolean = false;
  puAddCount: number = 0;
  puSourceCount: number = 0;
  puSourceDisableOnDelete: number = 0;
  puUnitSourceInputDisable: boolean = false;
  ProfileCountChangeSourceDisble: boolean = false;
  selectedSourceList: any[] = [];
  selectedUnitSourceList: any[] = [];
  exInfyProfileSelect = new UntypedFormControl('', Validators.required);
  exInfyProfilesCount = new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9][0-9]*$')]);
  exInfyProfilesResp: any;
  assignExinfyMsg: string = '';
  exInfyProfilesRespCount: any;
  exInfyprofileCountErrMsg: string = '';
  assignExinfySuccessMsg: string;
  exInfyUnitList: any[] = [];
  // @ViewChild('select', { static: false }) select:any;

  constructor(
    private modalService: NgbModal,
    private snackBar: MatSnackBar,
    private fb: UntypedFormBuilder,
    private teamService: TeamService,
    private datePipe: DatePipe,
  ) {
    this.filteredOptions = this.teamControl.valueChanges.pipe(
      startWith(''),
      map((state) => (state ? this._filter(state) : this.teamData.slice())),
    );
  }
  updateForm: UntypedFormGroup = this.fb.group({
    employeename: ['', [Validators.required]],
    fromdate: ['', [Validators.required]],
    todate: ['', [Validators.required]],
    time: ['', [Validators.required]],
    description: ['', [Validators.pattern('^[a-zA-Z ]*$')]],
  });

  unitSourceCountFormgroup: UntypedFormGroup = this.fb.group({
    unitCountArray: this.fb.array([]),
    // sourceCountArrayIL:this.fb.array([]),
    sourceCountArray: this.fb.array([]),
  });

  unitArrayControl = this.unitSourceCountFormgroup.controls.unitCountArray as UntypedFormArray;
  sourceArrayControl = this.unitSourceCountFormgroup.controls.sourceCountArray as UntypedFormArray;
  //sourceArrayControlIL = this.unitSourceCountFormgroup.controls.sourceCountArrayIL as FormArray;

  ngOnInit() {
    this.teamSearch.valueChanges.subscribe((res) => {
      this.filteredTeamData = this.teamMemberData.filter((x) =>
        x.employeeName.toLowerCase().includes(res.toLowerCase()),
      );
    });
    if (this.companyHiringType == '1') {
      this.addPU();
      this.puUnitSourceInputDisable = true;
      this.addSource();
      const unitReqBody = {
        companyHiringTypeId: this.companyHiringType,
        roleCode: this.role,
      };
      this.teamService.getUnitsList(unitReqBody).subscribe((res) => {
        if (res) {
          this.unitListArray = res;
          // this.exInfyUnitList=JSON.parse(JSON.stringify(this.unitListArray));
          // this.exInfyUnitList.unshift('ALL');
          // this.exInfyProfileSelect.setValue('ALL');
          // this.onExinfyOptionSelect(this.exInfyProfileSelect.value);
        }
      });
      this.getExInfyList();
    } else if (this.companyHiringType == '4' || this.companyHiringType == '9') {
      const sourceReqBody = {
        companyHiringTypeId: this.companyHiringType,
        roleCode: this.role,
      };
      this.teamService.getSourceList(sourceReqBody).subscribe((res) => {
        this.sourceListArray = res.sourceList;
        this.sourceIdwithType = res.sourcewithLinkSource;
        this.addSource();
      });
    }
    this.exInfyProfilesCount.valueChanges.subscribe((countResp) => {
      if (countResp > this.exInfyProfilesRespCount) {
        this.exInfyprofileCountErrMsg = 'Please enter count less than actual count.';
      } else if (countResp == 0 && countResp != '') {
        this.exInfyprofileCountErrMsg = "No. of profiles can't be 0.";
      } else {
        this.exInfyprofileCountErrMsg = '';
      }
    });
  }

  keyPressedAlphabets(e) {
    //disabled alphabets keys for  phone number
    const key = document.all ? e.keyCode : e.which;
    return (key > 64 && key < 91) || (key > 96 && key < 123) || key == 8 || key == 32;
  }

  getExInfyList() {
    const unitExinfybody = {
      companyHiringTypeId: this.companyHiringType,
      roleCode: this.role,
      exInfyFlag: 'Y',
    };

    this.teamService.getUnitsListExinfy(unitExinfybody).subscribe((res) => {
      if (res) {
        this.exInfyUnitList = res.filter((data) => data.count > 0);
        // console.log(this.exInfyUnitList,"unitss");
        this.exInfyUnitList.unshift({ unitCode: 'ALL', count: 0 });
        this.exInfyProfileSelect.setValue('ALL');
        this.onExinfyOptionSelect(this.exInfyProfileSelect.value);
      }
    });
  }

  getUnit(value, index) {
    this.selectedUnit = value;
    this.selectedUnitSourceList[index] = value;
    console.log(
      this.selectedUnit,
      'rr',
      this.selectedUnitSourceList,
      index,
      this.selectedUnitSourceList.includes(null),
    );
    if (this.selectedUnit && !this.selectedUnitSourceList.includes(null)) {
      this.disableAssign = false;
      this.puUnitSourceInputDisable = false;
    }
    const reqBody = {
      unitCode: this.selectedUnit,
      companyHiringTypeId: Number(this.companyHiringType),
      roleCode: this.role,
    };
    this.teamService.getUnitProfileCount(reqBody).subscribe((response) => {
      this.profilecount = response;
      const sourceReqBody = {
        idWithType: this.profilecount.idWithType,
      };
      this.teamService.getPUSourceList(sourceReqBody).subscribe((res) => {
        this.sourceListArray[reqBody.unitCode] = res;
      });
      this.unitArrayControl.at(index).get('maxCount').setValue(response);
      this.unitArrayControl.at(index).get('profileCount').setValue(response.count);
      if (this.unitArrayControl.at(index).get('profileCount').value == 0) {
        this.validateUnitCount(index);
      }
    });
    //profile count value change in PU other than original count
    this.unitArrayControl
      .at(index)
      .get('profileCount')
      .valueChanges.subscribe((data) => {
        this.validateUnitCount(index);
        if (data != this.unitArrayControl.at(index).get('maxCount').value.count) {
          for (let i = index + 1; i < this.unitArrayControl.value.length; i++) {
            if (this.unitArrayControl.at(i).get('units')) {
              break;
            }
            //disabling and making values null of source when profile value changes
            else {
              this.unitArrayControl.at(i).get('source').setValue('');
              this.unitArrayControl.at(i).get('profileCount').setValue(null);
              // this.unitArrayControl.at(i).get('source').clearValidators();
            }
          }
        } else {
          this.ProfileCountChangeSourceDisble = false;
        }
      });
  }

  //for pu Index
  getCurrentPuIndex(index) {
    let firstIndex;
    let lastIndex;
    for (let i = 0; i < this.unitArrayControl.value.length; i++) {
      if (this.unitArrayControl.at(i).get('units') && i < index) {
        firstIndex = i;
      } else if (this.unitArrayControl.at(i).get('units') && i > index) {
        lastIndex = i;
        break;
      }
    }
    lastIndex = lastIndex ? lastIndex : this.unitArrayControl.value.length;
    return { firstPUIndex: firstIndex, lastPUIndex: lastIndex };
  }

  //disable source  on profile count change in PU
  sourceReadOnly(index) {
    const PUIndexObj = this.getCurrentPuIndex(index);

    for (let j = PUIndexObj.firstPUIndex + 1; j < PUIndexObj.lastPUIndex; j++) {
      if (
        this.unitArrayControl.at(PUIndexObj.firstPUIndex).get('profileCount').value ||
        this.unitArrayControl.at(PUIndexObj.firstPUIndex).get('profileCount').value == 0
      ) {
        if (
          this.unitArrayControl.at(PUIndexObj.firstPUIndex).get('profileCount').value !=
          this.unitArrayControl.at(PUIndexObj.firstPUIndex).get('maxCount').value.count
        ) {
          //add code
        } else {
          return false;
        }
      }
    }
    return true;
  }

  getSource(value, index) {
    if (this.companyHiringType == '4' || this.companyHiringType == '9') {
      this.selectedSource = value;
      this.selectedSourceList[index] = value;
      //console.log("rr", this.selectedSourceList );

      if (this.selectedSource && !this.selectedSourceList.includes(null)) {
        this.disableAssign = false;
      }
      const reqBody = {
        sourceCode: this.selectedSource,
        companyHiringTypeId: Number(this.companyHiringType),
        roleCode: this.role,
        sourceWithLinkSource: this.sourceIdwithType,
      };
      this.teamService.getSourceProfileCount(reqBody).subscribe((response) => {
        this.profilecount = response;
        this.sourceArrayControl.at(index).get('profileCount').setValue(response['count']);
        this.sourceArrayControl.at(index).get('maxCount').setValue(response);
      });
    } else if (this.companyHiringType == '1') {
      this.selectedSource = value;
      this.selectedUnitSourceList[index] = value;
      //console.log("rr",this.selectedUnitSourceList);
      if (this.selectedSource && !this.selectedUnitSourceList.includes(null)) {
        this.disableAssign = false;
      }
      //console.log(this.selectedSource, "sou");
      const PUIndexObj = this.getCurrentPuIndex(index);
      const reqBody = {
        unitCode: this.unitArrayControl.at(PUIndexObj.firstPUIndex).get('units').value,
        companyHiringTypeId: Number(this.companyHiringType),
        roleCode: this.role,
        source: this.selectedSource,
      };
      this.teamService.getUnitProfileCount(reqBody).subscribe((response) => {
        this.profilecount = response;
        this.unitArrayControl.at(index).get('maxCount').setValue(response);
        this.unitArrayControl.at(index).get('profileCount').setValue(response.count);
      });
    }
  }

  //to dissable source channel options once selected
  disableUnitSource(value, profileType, index) {
    if (this.companyHiringType == '1') {
      if (profileType == 'unit') {
        let checkUnit = false;
        for (const ele of this.unitArrayControl.value) {
          if (ele.units == value) {
            checkUnit = true;
            break;
          }
        }
        return checkUnit;
      } else {
        let checkSource = false;
        const PUIndexObj = this.getCurrentPuIndex(index);
        for (let i = PUIndexObj.firstPUIndex + 1; i < PUIndexObj.lastPUIndex; i++) {
          if (this.unitArrayControl.value[i].source == value) {
            checkSource = true;
            break;
          }
        }
        return checkSource;
      }
    } else if (this.companyHiringType == '4' || this.companyHiringType == '9') {
      let checkSource = false;
      for (const ele of this.sourceArrayControl.value) {
        if (ele.source == value) {
          checkSource = true;
          break;
        }
      }
      return checkSource;
    }
  }
  getUnitControls() {
    return (this.unitSourceCountFormgroup.get('unitCountArray') as UntypedFormArray).controls;
  }

  getSourceControls() {
    return (this.unitSourceCountFormgroup.get('sourceCountArray') as UntypedFormArray).controls;
  }
  getSourceControlsIL() {
    return (this.unitSourceCountFormgroup.get('sourceCountArrayIL') as UntypedFormArray).controls;
  }

  clearInput() {
    this.showInput = !this.showInput;
    this.filteredTeamData = this.teamData.filter((res) => res.active == true);
    this.teamSearch.patchValue('');
  }

  toggle(team) {
    this.isOpen = team['checked'] ? !this.isOpen : this.isOpen;
    document.getElementById('overlay').style.display = this.isOpen ? 'block' : 'none';
    if (this.isOpen) {
      document.getElementById('teamDiv').classList.add('noPointer');
    } else {
      document.getElementById('teamDiv').classList.remove('noPointer');
    }
    if (this.isOpen) {
      this.ontoggleOpen();
    }
  }

  ontoggleOpen() {
    this.getExInfyList();
    this.exInfyProfileSelect.setValue('ALL');
    this.onExinfyOptionSelect(this.exInfyProfileSelect.value);
  }

  close() {
    this.isOpen = false;
    document.getElementById('overlay').style.display = 'none';
    document.getElementById('teamDiv').classList.remove('noPointer');
    this.filteredTeamData.forEach((team) => (team['checked'] = false));
    this.teamArray = [];
    if (this.companyHiringType == '1') {
      this.unitArrayControl.clear();
      this.puAddCount = 0;
      this.addPU();
      this.puUnitSourceInputDisable = true;
      this.addSource();
    } else if (this.companyHiringType == '4' || this.companyHiringType == '9') {
      this.sourceArrayControl.clear();
      this.addSource();
    }
    this.hideDeleteBtn = false;
    this.disableAssign = false;
    this.selectedUnitSourceList = [];
    this.selectedSourceList = [];
    this.exInfyProfileSelect.reset();
    this.exInfyProfilesCount.reset();
    this.assignExinfyMsg = '';
    this.exInfyprofileCountErrMsg = '';
    this.assignExinfySuccessMsg = '';
  }

  addPU() {
    this.puAddCount++;
    this.puSourceDisableOnDelete = 0;
    this.unitArrayControl.push(
      this.fb.group({
        units: ['', Validators.required],
        profileCount: ['', [Validators.required, Validators.pattern('^[1-9][0-9]*$')]],
        maxCount: [''],
        hideShowBtn: [false],
      }),
    );
    let count = 0;
    this.unitArrayControl.value.forEach((element, key) => {
      if (this.unitArrayControl.at(key).get('units')) {
        count = key;
      }
    });

    this.filtered_Units(count);
  }

  filtered_Units(index: number) {
    this.filteredUnits[index] = this.unitArrayControl
      .at(index)
      .get('units')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (value ? this.unitFilter(value, index) : this.unitListArray.slice())),
      );
  }

  unitFilter(value, index) {
    const filterValue = value.toLowerCase();
    this.selectedUnitSourceList[index] = null;
    this.selectedUnit = null;
    //console.log("sp",this.selectedUnitSourceList,index);
    this.disableAssign = true;
    // this.unitArrayControl.at(index).get('profileCount').setValue(null);
    this.puUnitSourceInputDisable = true;
    return this.unitListArray.filter((option) => option.toLowerCase().includes(filterValue));
  }

  addSource() {
    // this.puSourceCount++
    if (this.companyHiringType == '4' || this.companyHiringType == '9') {
      this.sourceArrayControl.push(
        this.fb.group({
          source: ['', Validators.required],
          profileCount: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
          maxCount: [''],
          hideShowBtn: [false],
        }),
      );
      this.filtered_Source(this.sourceArrayControl.length - 1);
    } else if (this.companyHiringType == '1') {
      this.unitArrayControl.push(
        this.fb.group({
          source: [''],
          profileCount: ['', [Validators.pattern('^[1-9][0-9]*$')]],
          maxCount: [''],
          hideShowBtn: [false],
        }),
      );
      console.log(this.unitArrayControl);

      //to disable add new source button
      let count = 0; //last index of source
      this.unitArrayControl.value.forEach((element, key) => {
        if (this.unitArrayControl.at(key).get('units')) {
          this.puSourceDisableOnDelete = 0;
        }
        if (this.unitArrayControl.at(key).get('source')) {
          count = key;
          this.puSourceDisableOnDelete++;
        }
      });

      this.filtered_Source(count);
    }
  }

  filtered_Source(index: number) {
    if (this.companyHiringType == '4' || this.companyHiringType == '9') {
      this.filteredSource[index] = this.sourceArrayControl
        .at(index)
        .get('source')
        .valueChanges.pipe(
          startWith(''),
          map((value) => (value ? this.sourceFilter(value, index) : this.sourceListArray.slice())),
        );
    } else if (this.companyHiringType == '1') {
      //console.log("fsa", this.filteredSource[index]);
      this.filteredSource[index] = this.unitArrayControl
        .at(index)
        .get('source')
        .valueChanges.pipe(
          startWith(''),
          map((value) => (value ? this.sourceFilter(value, index) : this.sourceSlice(index))),
        );
    }
  }

  sourceSlice(index) {
    const PUIndexObj = this.getCurrentPuIndex(index);
    this.unitArrayControl.at(index).get('profileCount').reset();
    this.disableAssign = false;
    //console.log(this.sourceListArray,"sp");
    return this.sourceListArray[this.unitArrayControl.at(PUIndexObj.firstPUIndex).get('units').value];
  }

  sourceFilter(value, index) {
    const filterValue = value.toLowerCase();
    if (this.companyHiringType == '1') {
      const PUIndexObj = this.getCurrentPuIndex(index);
      this.disableAssign = true;
      this.selectedUnitSourceList[index] = null;
      this.selectedSource = null;
      //console.log("sp",this.selectedUnitSourceList);
      // this.sourceArrayControl.at(index).get('profileCount').setValue(null);
      return this.sourceListArray[this.unitArrayControl.at(PUIndexObj.firstPUIndex).get('units').value].filter(
        (option) => option.toLowerCase().includes(filterValue),
      );
    } else {
      this.selectedSourceList[index] = null;
      this.disableAssign = true;
      //console.log("sp",this.selectedSourceList);
      this.selectedSource = null;
      return this.sourceListArray.filter((option) => option.toLowerCase().includes(filterValue));
    }
  }

  deleteUnitSourceRow(index, profilestype) {
    if (this.companyHiringType == '1') {
      if (profilestype == 'unit') {
        this.puAddCount--;
        const sourceIndArr = [];
        for (let i = index + 1; i < this.unitArrayControl.value.length; i++) {
          if (this.unitArrayControl.at(i).get('units')) {
            break;
          } else {
            sourceIndArr.push(i);
          }
        }
        for (let i = sourceIndArr.length - 1; i >= 0; i--) {
          this.unitArrayControl.removeAt(sourceIndArr[i]);
        }
      }
    }
    this.unitArrayControl.removeAt(index);
    this.sourceArrayControl.removeAt(index);
    this.selectedUnitSourceList.splice(index, 1);
    this.selectedSourceList.splice(index, 1);
    this.unitArrayControl.value.forEach((element, key) => {
      if (this.unitArrayControl.at(key).get('units')) {
        this.validateUnitCount(key);
        this.puSourceDisableOnDelete = 0;
      }
      if (this.unitArrayControl.at(key).get('source')) {
        this.validateSourceCount(key);
        this.puSourceDisableOnDelete++;
      }
    });

    if (this.companyHiringType == '4') {
      if (this.selectedSourceList.includes(null)) {
        this.disableAssign = true;
      } else {
        this.disableAssign = false;
      }
    }
  }

  private _filter(value: string): TeamMemberDetails[] {
    const filterValue = value.toLowerCase();
    //indexOf(filterValue) === 0
    return this.teamData.filter((state) => state.employeeName.toLowerCase().includes(filterValue));
  }
  ngDoCheck() {
    if (this.teamData) {
      this.leaveCount = this.teamData.filter((val) => val.flag == 0).length;
      this.activeState = this.teamData.filter((res) => res.active == false).length;
    }
  }

  ngOnChanges() {
    if (this.role == 'VLAD' || this.role == 'DCAD') {
      this.teamMemberData = this.filteredTeamData = this.teamData.filter((res) => res.active == true);
    } else {
      this.teamMemberData = this.filteredTeamData = this.teamData;
    }
  }
  open(content, index: number) {
    this.updateForm.reset();
    this.selectedData = this.filteredTeamData[index];
    this.selectedMember = this.selectedData.employeeNumber;
    this.selectedMemberRole = this.selectedData.roleCode;
    this.modalService.open(content, { windowClass: 'custom_modal' });
  }
  addMember() {
    this.addMemberData.companyHiringTypeId = parseInt(this.companyHiringType);
    this.addMemberData.roleCode = this.role;
    this.addMemberData.employeeNumber = this.addDetails.employeeNumber;
    this.addTeamMember.emit(this.addMemberData);
    this.edited = false;
    this.inputText = '';
    this.addMemberData = <AddTeam>{};
    this.addDetails = <TeamDetails>{};
  }
  onMemberSelect(memberData) {
    this.memberDetails = memberData;
  }

  onMemberadd(memberData) {
    this.addDetails = memberData;
  }
  add() {
    this.errorMessage = null;
    this.edited = true;
  }
  changeIcon(team) {
    if (this.role == 'VLAD' || this.role == 'DCAD') {
      if (
        (this.companyHiringType == '1' || this.companyHiringType == '4' || this.companyHiringType == '9') &&
        !this.disableallocate
      ) {
        team['checked'] = team['checked'] ? false : true;
        if (team['checked'] == true) {
          this.teamArray.push(team.employeeNumber);
        } else {
          const ind = this.teamArray.indexOf(team.employeeNumber);
          if (ind !== -1) {
            this.teamArray.splice(ind, 1);
          }
        }
        if (this.teamArray.length == 0) {
          this.isOpen = false;
          document.getElementById('overlay').style.display = 'none';
        }
      }
    }
  }
  updateLeave(_close) {
    this.updateTeamData.companyHiringTypeId = parseInt(this.companyHiringType);
    this.updateTeamData.roleCode = this.selectedMemberRole;
    this.updateTeamData.employeeNumber = this.selectedMember;
    this.updateTeamData.startDate = this.datePipe.transform(this.updateForm.value.fromdate, 'yyyy-MM-dd');
    this.updateTeamData.endDate = this.datePipe.transform(this.updateForm.value.todate, 'yyyy-MM-dd');
    this.updateTeamData.duration = this.updateForm.value.time;
    this.updateTeamData.remarks = this.updateForm.value.description;
    if (this.updateTeamData.endDate < this.updateTeamData.startDate) {
      //this.updateForm.disable;
    }
    this.leaveUpdate.emit(this.updateTeamData);
    // this.getExInfyList();
  }
  validateRegex(event) {
    const regex = /^[a-zA-Z ]*$/;
    const result = regex.test(event);
    if (result) {
      this.errorMessage = null;
    } else {
      this.errorMessage = 'Special Characters and Numbers are not allowed';
    }
    return result;
  }

  validateUnitCount(index) {
    const unitcount = this.unitArrayControl.at(index).get('profileCount');
    const unitmaxCount = this.unitArrayControl.at(index).get('maxCount').value.count;
    const regex = /^[1-9][0-9]*$/;
    const unitResult = regex.test(unitcount.value);
    if (!unitResult) {
      return;
    }
    if (unitcount.value == '0' || this.selectedUnitSourceList.includes(null)) {
      this.disableAssign = true;
    } else {
      this.disableAssign = false;
      this.puUnitSourceInputDisable = false;
    }
    if (unitcount.value) {
      if (unitcount.value > unitmaxCount) {
        unitcount.setErrors({ maxError: true });
      } else {
        unitcount.setErrors(null);
      }
    } else {
      unitcount.setErrors({ required: true });
    }
  }

  validateSourceCount(index) {
    let sourcecount;
    let sourcemaxCount;
    let regex;
    if (this.companyHiringType == '4') {
      sourcecount = this.sourceArrayControl.at(index).get('profileCount');
      sourcemaxCount = this.sourceArrayControl.at(index).get('maxCount').value.count;
      regex = /^[0-9]*$/;
    } else {
      sourcecount = this.unitArrayControl.at(index).get('profileCount');
      sourcemaxCount = this.unitArrayControl.at(index).get('maxCount').value.count;
      if ((sourcecount.value == '' && sourcemaxCount) || this.selectedUnitSourceList.includes(null)) {
        this.disableAssign = true;
      }
      regex = /^[1-9][0-9]*$/;
    }
    const sourceResult = regex.test(sourcecount.value);
    if (!sourceResult) {
      return;
    }
    if (
      sourcecount.value == '0' ||
      (this.companyHiringType == '1' && this.selectedUnitSourceList.includes(null)) ||
      (this.companyHiringType == '4' && this.selectedSourceList.includes(null))
    ) {
      //console.log("validate",this.selectedSourceList.includes(null),this.selectedSourceList);

      this.disableAssign = true;
    } else {
      this.disableAssign = false;
      this.puUnitSourceInputDisable = false;
    }
    if (sourcecount.value) {
      if (sourcecount.value > sourcemaxCount) {
        sourcecount.setErrors({ maxError: true });
      } else {
        sourcecount.setErrors(null);
      }
    } else {
      if (this.companyHiringType == '4') {
        sourcecount.setErrors({ required: true });
      }
    }
  }

  deleteTeamMember(employeeNumber) {
    this.deleteTeamData.employeeNumber = employeeNumber;
    this.deleteTeamData.eventId = this.eventDetails ? this.eventDetails.eventId : 0;
    this.deleteTeamData.companyHiringTypeId = parseInt(this.companyHiringType);
    this.deleteMember.emit(this.deleteTeamData);
  }
  closeUpdate() {
    this.inputText = '';
    this.edited = false;
  }
  onSubmit(_formValue) {}

  Allocate() {
    const allocateTeam = [];
    this.filteredTeamData.forEach((team, _index) => {
      if (team.flag == 1 && team.active == true) {
        allocateTeam.push(team.employeeNumber);
      }
    });
    this.autoAllocate.emit(allocateTeam);
  }
  assignProfiles() {
    const countArray = [];
    let checkBoolean;
    if (this.companyHiringType == '1') {
      const emptyInd = [];
      this.unitArrayControl.value.forEach((ele, key) => {
        if (ele['source'] == '') {
          emptyInd.push(key);
        }
      });
      for (let i = emptyInd.length - 1; i >= 0; i--) {
        this.unitArrayControl.removeAt(emptyInd[i]);
      }
      this.unitArrayControl.value.forEach((element, index) => {
        let reqBody;
        if (this.unitArrayControl.at(index).get('source')) {
          reqBody = {
            associateEmpNo: this.teamArray,
            roleCode: this.role,
            companyHiringTypeId: this.companyHiringType,
            unitCode: element.source,
            count: Number(element.profileCount),
            obj: element.maxCount.idWithType,
          };
        } else if (this.unitArrayControl.at(index).get('units')) {
          if (
            (this.unitArrayControl.value.length > index + 1 && !this.unitArrayControl.at(index + 1).get('source')) ||
            this.unitArrayControl.value.length - 1 == index
          ) {
            reqBody = {
              associateEmpNo: this.teamArray,
              roleCode: this.role,
              companyHiringTypeId: this.companyHiringType,
              unitCode: element.units,
              count: Number(element.profileCount),
              obj: element.maxCount.idWithType,
            };
          }
        }
        if (reqBody) {
          this.disableAssign = true;
          this.teamService.assignProfiles(reqBody).subscribe((res) => {
            if (res.id == 0) {
              countArray.push(res.id);
              this.unitArrayControl.at(index).get('hideShowBtn').setValue(true);
              this.hideDeleteBtn = true;
              if (index == this.unitArrayControl.value.length - 1) {
                this.autoAllocate.emit(true);
              }
            } else {
              this.hideDeleteBtn = true;
              countArray.push(res.id);
              if (index == this.unitArrayControl.value.length - 1) {
                checkBoolean = countArray.includes(0, 0);
                if (checkBoolean) {
                  this.autoAllocate.emit(true);
                } else {
                  this.autoAllocate.emit(false);
                }
              }
            }
          });
        }
      });
    } else if (this.companyHiringType == '4' || this.companyHiringType == '9') {
      this.sourceArrayControl.value.forEach((element, index) => {
        const reqBody = {
          associateEmpNo: this.teamArray,
          roleCode: this.role,
          companyHiringTypeId: this.companyHiringType,
          unitCode: element.source,
          count: Number(element.profileCount),
          obj: element.maxCount.idWithType,
        };
        console.log(reqBody);
        this.disableAssign = true;
        this.teamService.assignProfiles(reqBody).subscribe((res) => {
          if (res.id == 0) {
            countArray.push(res.id);
            this.sourceArrayControl.at(index).get('hideShowBtn').setValue(true);
            this.hideDeleteBtn = true;
            if (index == this.sourceArrayControl.value.length - 1) {
              this.autoAllocate.emit(true);
            }
          } else {
            this.hideDeleteBtn = true;
            countArray.push(res.id);
            if (index == this.sourceArrayControl.value.length - 1) {
              checkBoolean = countArray.includes(0, 0);
              if (checkBoolean) {
                this.autoAllocate.emit(true);
              } else {
                this.autoAllocate.emit(false);
              }
            }
          }
        });
      });
    }
  }

  //on ex-infosys unit or all select
  onExinfyOptionSelect(optionSelectedEvent) {
    console.log(optionSelectedEvent, 'Exinfy selected');
    this.assignExinfySuccessMsg = '';
    const reqBody = {
      unitCode: optionSelectedEvent,
      companyHiringTypeId: Number(this.companyHiringType),
      roleCode: this.role,
      exInfoscianFlag: 'Y',
    };
    this.teamService.getUnitProfileCount(reqBody).subscribe(
      (response) => {
        if (response) {
          console.log(response, 'count');
          this.exInfyprofileCountErrMsg = '';
          this.exInfyProfilesResp = response;
          this.exInfyProfilesRespCount = response.count;
          this.exInfyProfilesCount.setValue(response.count);
        }
      },
      (_error) => {
        this.exInfyprofileCountErrMsg = 'Something went wrong.';
      },
    );
  }

  assignExinfyProfiles() {
    //console.log("assign inside");
    if (!this.exInfyProfileSelect.value || !this.exInfyProfilesCount.value) {
      this.exInfyProfileSelect.markAllAsTouched();
      this.exInfyProfilesCount.markAllAsTouched();
    }

    if (
      this.exInfyProfileSelect.value &&
      this.exInfyProfilesCount.value &&
      !this.exInfyprofileCountErrMsg &&
      this.exInfyProfilesCount.valid
    ) {
      const reqBody = {
        associateEmpNo: this.teamArray,
        roleCode: this.role,
        companyHiringTypeId: this.companyHiringType,
        unitCode: this.exInfyProfileSelect.value,
        count: Number(this.exInfyProfilesCount.value),
        obj: this.exInfyProfilesResp.idWithType,
      };

      if (reqBody) {
        this.teamService.assignProfiles(reqBody).subscribe(
          (res) => {
            if (res.id == 0) {
              this.assignExinfySuccessMsg = 'Successfully assigned profiles.';
              this.autoAllocate.emit(true);
              this.getExInfyList();
            } else {
              // this.assignExinfyMsg="Something went wrong"
              this.autoAllocate.emit(false);
            }
          },
          (_error) => {
            this.assignExinfyMsg = 'Something went wrong';
          },
        );
      }
    }
  }

  showInputClick() {
    this.showInput = true;
  }
}
